<template>
  <div class="personalIndex xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="3"></hd-img>
        </div>
        <div class="personal-right">
          <div class="content">
            <div class="flex-start">
              <div class="line-title"></div>
              <div class="pageTitle">充值管理</div>
            </div>
            <div class="flex-center">
              <div class="part-box">
                <el-form :model="RechargeForm" status-icon ref="RechargeForm" label-width="100px" class="demo-RechargeForm" :rules="rules">
                  <el-form-item label="充值金额" prop="money">
                    <el-input-number v-model="RechargeForm.money" :precision="2" :step="1" :min="0.0" controls-position="right" style="width: 300px" />
                  </el-form-item>
                  <el-form-item label="支付方式">
                    <div class="flex-start">
                      <div class="payWay" :class="{ payWayActive: RechargeForm.type == 1 }" @click="RechargeForm.type = 1">
                        <img class="img1" src="../../assets/img/userInfo/wx.png" />
                        <img class="jiaoImg" :class="{ activeImg: RechargeForm.type == 1 }" v-if="RechargeForm.type == 1" src="../../assets/img/userInfo/checked.png" />
                      </div>
                      <div class="payWay" :class="{ payWayActive: RechargeForm.type == 2 }" @click="RechargeForm.type = 2">
                        <img class="img1" src="../../assets/img/userInfo/zfb.png" />
                        <img class="jiaoImg" :class="{ activeImg: RechargeForm.type == 2 }" v-if="RechargeForm.type == 2" src="../../assets/img/userInfo/checked.png" />
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="RechargeSave('RechargeForm')">确 定</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付 -->
    <el-dialog title="" :visible.sync="PaymentDialog" :before-close="handleClose" width="400px">
      <div style="text-align: center" v-if="RechargeForm.type == 1">打开微信扫一扫充值</div>
      <div style="text-align: center" v-if="RechargeForm.type == 2">打开支付宝扫一扫充值</div>
      <div style="text-align: center; color: #f85659; font-weight: bold">
        <span>￥</span>
        <span style="font-size: 25px">{{ RechargeForm.money }}</span>
      </div>
      <div class="pay-bg" v-if="RechargeForm.type == 1">
        <img :src="qRcodeUrl" alt="" />
      </div>
      <div class="flex-center" v-else>
        <iframe :srcdoc="qRcodeUrl" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="200" height="200" style="overflow: hidden"> </iframe>
      </div>
    </el-dialog>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { UserInfo } from "../../components/User/UserInfo";
import { shoppingMall } from "../../components/shoppingMall/shoppingMall";
export default {
  inject: ["reload"],
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var user = new UserInfo(this.TokenClient, this.Services.Authorization);
    var users = new UserInfo(this.TokenClient, this.Services.Statics);
    var UserDistributorltem = new shoppingMall(this.TokenClient, this.Services.Authorization);
    return {
      userDomain: user,
      userDomainS: users,
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      rules: {
        money: [{ required: true, message: "请输入充值金额", trigger: "blur" }],
      },
      RechargeForm: {
        money: "",
        type: "1",
      },
      weChatInfo: {},
      qRcodeUrl: "",
      timer: null,
      UserDistributorMain: UserDistributorltem,
      PaymentDialog: false,
    };
  },
  mounted() {},
  methods: {
    handleClose() {
      clearInterval(this.timer);
      this.PaymentDialog = false;
    },
    RechargeSave(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (_this.RechargeForm.money <= 0) {
            _this.$message({
              type: "error",
              message: "金额必须大于0",
            });
            return
          }
          var parmas = {
            amount: _this.RechargeForm.money,
            id: _this.userInfo.id,
            orderNum: "",
            type: _this.RechargeForm.type,
            attach: "recharge",
            RechargeType: 2,//0机构 1代理商 2个人
          };
          _this.UserDistributorMain.Recharge(
            parmas,
            function (data) {
              // 微信
              if (_this.RechargeForm.type == 1) {
                _this.qRcodeUrl = `data:image/png;base64,${data.data.qRcodeBase64}`;
                _this.weChatInfo = data.data;
              } else {
                // 支付宝
                _this.weChatInfo.orderNo = data.data.orderNo;
                _this.qRcodeUrl = data.data.alipayData;
                _this.weChatInfo.attach = "recharge";
              }
              _this.PaymentDialog = true;
              var isSuccess = false;
              _this.timer = window.setInterval(() => {
                setTimeout(function () {
                  _this.UserDistributorMain.WeChatPayVerificationSuccessPay(
                    _this.weChatInfo,
                    function (data2) {
                      isSuccess = data2.data.isSuccess;
                      if (isSuccess) {
                        clearInterval(_this.timer);
                        _this.$message({
                          type: "success",
                          message: "支付成功!",
                        });
                        _this.PaymentDialog = false;
                      }
                    },
                    function (error) {
                      console.log(error);
                    }
                  );
                }, 0);
              }, 5000);
              setTimeout(() => {
                if (!isSuccess) {
                  clearInterval(_this.timer);
                  if (_this.PaymentDialog) {
                    _this.$message({
                      type: "error",
                      message: "支付超时!",
                    });
                    _this.PaymentDialog = false;
                  }
                }
              }, 300000);
            },
            function (error) {
              console.log(error);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/css/footer.css";
.personal-content {
  background: #f2f2f2;
  padding: 40px 0;
}
.personal-box {
  width: 1200px;
  margin: 0 auto;
}
.personal-left {
  float: left;
}
.personal-right {
  float: right;
  width: 985px;
}

.pointer {
  cursor: pointer;
}
.line-title {
  width: 3px;
  height: 16px;
  background: #333;
  margin-right: 5px;
}
.pageTitle {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  min-height: 640px;
}
.part-box {
  // width: 50%;
  margin: 0 auto;
  margin-top: 10%;
  .desc {
    margin-top: 10px;
  }
  .tip {
    width: 100%;
    color: #00a391;
    text-align: center;
  }
  .payWay {
    padding: 10px 60px 0 60px;
    border: 1px solid #e0e0e0;
    margin-right: 20px;
    position: relative;
    cursor: pointer;
  }
  .payWayActive {
    border: 1px solid #1fb7a6;
  }
  .jiaoImg {
    position: absolute;
    right: 0;
  }
  .activeImg {
    bottom: -1px;
  }
  .imgBoxurl1 {
    width: 180px;
    height: 180px;
  }
}
.pay-bg {
  position: relative;
  margin: 20px auto;
  width: 180px;
  height: 180px;
  background: url("../../assets/img/userInfo/pc_line.png") top center no-repeat;
  background-size: cover;
}

.pay-bg img {
  position: absolute;
  width: 160px;
  top: 10px;
  left: 10px;
}
</style>
